import memoizeOne from 'memoize-one';
import get from 'lodash/get';
import { INTERNAL_UNKNOWN, UNKNOWN } from '../constants';

const DESC = 'desc';

const isUnknown = value => value === INTERNAL_UNKNOWN || value === UNKNOWN;

const memoizeDataSource = (dataSource) => {
  if (!Array.isArray(dataSource)) {
    return dataSource;
  }
  const unknownRowIndex = dataSource.findIndex((row) => {
    const rowValue = get(row, 'value', []).join('');
    return isUnknown(rowValue);
  });
  if (unknownRowIndex === -1) {
    return dataSource;
  }
  const unknownRow = dataSource.splice(unknownRowIndex, 1)[0];
  dataSource.push(unknownRow);
  return dataSource;
};

const cacheDataSource = memoizeOne(memoizeDataSource);

const unknownDimensionSorter = (prevColumn, currentColumn, rowData) => {
  const { order, prevRow, currentRow } = rowData;
  const prevRowValue = get(prevRow, 'value', []).join('');
  const currentRowValue = get(currentRow, 'value', []).join('');
  if (isUnknown(prevRowValue) || isUnknown(currentRowValue)) {
    return 1;
  }

  return order === DESC ? currentColumn - prevColumn : prevColumn - currentColumn;
};

export default cacheDataSource;

export { unknownDimensionSorter };
